import { render, staticRenderFns } from "./UpdateAccountant.vue?vue&type=template&id=79dd9779"
import script from "./UpdateAccountant.vue?vue&type=script&lang=js"
export * from "./UpdateAccountant.vue?vue&type=script&lang=js"
import style0 from "./UpdateAccountant.vue?vue&type=style&index=0&id=79dd9779&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports